import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {switchMap, tap} from 'rxjs/operators';
import {EMPTY, Observable, of} from 'rxjs';
import {MatPaginator} from '@angular/material/paginator';
import {Sort} from "@angular/material/sort";
import {DialogsService} from "../../../services/dialogs.service";
import {SnackService} from "../../../services/snack.service";
import {
  GeneralItemDetailDialogComponent
} from "../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import {BoxInterface} from "../../../model/box-interface";
import {BoxInterfacesService} from "../../../services/box-interfaces.service";
import {CreateBoxInterfaceDialogComponent} from "../create-box-interface-dialog/create-box-interface-dialog.component";
import {Constants} from "../../../utils/constants";
import {AuthService} from "../../../services/auth.service";
import {Box} from "../../../model/box";
import {AddBoxInterfaceDialogComponent} from "../../boxes/add-box-interface-dialog/add-box-interface-dialog.component";
import {hasPermission, User} from "../../../model/user";


@Component({
  selector: 'aw-list-box-interfaces',
  templateUrl: './list-box-interfaces.component.html',
  styleUrls: ['./list-box-interfaces.component.scss']
})
export class ListBoxInterfacesComponent implements OnInit, AfterViewInit {

  public displayedColumns = [

    'name',
    'description',
    // 'box',
    'action'
  ];
  disabled = false;
  disabledItemId: number[] = [];
  loading = false;
  @ViewChild('paginatorBoxInterfaces') paginatorUsers!: MatPaginator;
  @Input() embeddedLayout = false;
  @Input() box?: Box;
  dataSource!: MatTableDataSource<BoxInterface>;
  entities = Constants.entities;
  iAmAdmin = false;
  loggedUser?: User;
  private allBoxInterfaces$!: Observable<BoxInterface[]>;

  constructor(
    public dialog: MatDialog,
    private boxInterfacesService: BoxInterfacesService,
    private dialogsService: DialogsService,
    private snackService: SnackService,
    private authService: AuthService,
  ) {
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();
    this.iAmAdmin = hasPermission(this.loggedUser, "admin");
  }

  ngAfterViewInit(): void {
    this.allBoxInterfaces$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => {
            if (this.box)
              return this.boxInterfacesService.getBoxInterfacesByBox(this.box.id);

            return this.boxInterfacesService.getAllBoxInterfaces();
          }),
          tap(x => {
            this.dataSource = new MatTableDataSource<BoxInterface>(x);
            this.dataSource.paginator = this.paginatorUsers;
            this.loading = false;
          })
        );
    this.allBoxInterfaces$.subscribe();
  }

  applyFilters(event: string): void {
    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortInterfaces(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {


      const index: string = event.active;

      if (event.direction === 'asc') {
        return ('' + (b as any)[index]).localeCompare('' + (a as any)[index]);
      } else {
        return ('' + (a as any)[index]).localeCompare('' + (b as any)[index]);
      }

    });
  }

  details(boxInterface: BoxInterface): void {
    this.dialog.open(GeneralItemDetailDialogComponent, {data: boxInterface});
  }

  createBoxInterface(): void {
    this.disabled = true;
    this.dialog
      .open(CreateBoxInterfaceDialogComponent, {data: new BoxInterface()})
      .afterClosed()
      .pipe(switchMap(value => value ? this.allBoxInterfaces$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  editBoxInterface(boxInterface: BoxInterface): void {
    this.disabled = false;
    this.dialog
      .open(CreateBoxInterfaceDialogComponent, {data: {boxInterface: boxInterface, creatingFromBox: false}})
      .afterClosed()
      .pipe(switchMap(value => value ? this.allBoxInterfaces$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  deleteBoxInterface(boxInterface: BoxInterface): void {
    this.disabled = true;
    const id = boxInterface.id ?? -1;
    this.disabledItemId.push(id);
    this.dialogsService
      .confirm('Delete box interface', `Are you sure you want to delete the box interface "${boxInterface.name}"?`)
      .pipe(
        switchMap((value) => value ?
          this.boxInterfacesService.deleteBoxInterface(<number>boxInterface.id) :
          EMPTY),
        switchMap(() => this.allBoxInterfaces$)
      )
      .subscribe(() => {
          this.disabled = false;
          this.snackService.success('Box interface deleted!');
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        }, (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        },
        () => {
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        });

  }

  addBoxInterfaces(box?: Box): void {
    this.disabled = true;
    this.dialog
      .open(AddBoxInterfaceDialogComponent, {data: box})
      .afterClosed()
      .pipe(switchMap(value => value ? this.allBoxInterfaces$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });

  }

  removeBoxInterface(boxInterface: BoxInterface): void {
    this.disabled = true;
    const id = boxInterface.id ?? -1;
    this.disabledItemId.push(id);
    this.dialogsService
      .confirm('Remove box interface', `Are you sure you want to remove the bov interface "${boxInterface.name}" from the box "${this.box?.identifier}"?`)
      .pipe(
        switchMap((value) => value ?
          this.boxInterfacesService.deleteBoxInterfaceAssociation(<number>this.box?.id, <number>boxInterface?.id) :
          EMPTY),
        switchMap(() => this.allBoxInterfaces$)
      )
      .subscribe(() => {
          this.disabled = false;
          this.snackService.success('Box interface removed!');
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        }, (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        },
        () => {
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        });

  }


}
